import React from 'react';
import { number, string, func } from 'prop-types';
import styled from 'styled-components';

// Import components
import { AuthModal } from 'components/elements';
import { Root } from './styles';
import GradientButton from './GradientButton';

// Import assets
import { ReactComponent as VodHeartIcon } from 'assets/icons/vod_heart.svg';
import { ReactComponent as VodHeartFullIcon } from 'assets/icons/vod_heart_full.svg';

// Import hooks
import { useFavouriteButton } from './hooks';

export function FavouriteButton({ uuid, width, height, GTMEvent }) {
	const { ref, handleClick, buttonText, isFavourite } = useFavouriteButton({
		uuid,
		GTMEvent
	});

	return (
		<AuthModal>
			<Root onClick={handleClick} ref={ref} width={width} height={height}>
				<GradientButton
					ref={ref}
					text={buttonText}
					icon={
						isFavourite ? <VodHeartFullIconStyled /> : <VodHeartIconStyled />
					}
				/>
			</Root>
		</AuthModal>
	);
}

const VodHeartIconStyled = styled(VodHeartIcon)`
	height: 1.8rem;
	stroke-width: 0.3rem;
	stroke: #fff;
`;

const VodHeartFullIconStyled = styled(VodHeartFullIcon)`
	height: 1.8rem;

	path {
		fill: #fff;
	}
`;

FavouriteButton.defaultProps = {
	width: 238,
	height: 59
};

FavouriteButton.propTypes = {
	uuid: string.isRequired,
	width: number,
	height: number,
	GTMEvent: func
};
